export function setIcon(el, iconName) {
  el.innerHTML = "";
  el.appendChild(create(iconName));
}

/**
 * Create an icon element.
 *
 * @param {String} iconName The name of the icon
 * @param {Object} options
 * @param {"sm" | "xs"} [options.size = "sm"] The size of the icon
 * @returns {HTMLElement}
 */
export function create(iconName, options = {}) {
  const { size = "sm" } = options;

  const svgEl = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svgEl.classList.add("icon", iconSizeClass(size));
  svgEl.setAttribute("fill", "currentColor");
  svgEl.setAttribute("aria-hidden", "true");

  const useEl = document.createElementNS("http://www.w3.org/2000/svg", "use");
  useEl.setAttribute("href", iconPath(iconName));
  svgEl.appendChild(useEl);

  return svgEl;
}

function iconSizeClass(size) {
  switch (size) {
    case "sm":
      return "icon--sm";
    case "xs":
      return "icon--xs";
    default:
      throw new Error(`Invalid icon size: ${size}`);
  }
}

function iconPath(iconName) {
  return `/icons/sprite.svg#${iconName}`;
}

export function createIconOnlyButton(iconName) {
  const buttonEl = document.createElement("button");
  buttonEl.classList.add("button", "button--ghost", "button--icon-only");
  buttonEl.appendChild(create(iconName));
  return buttonEl;
}
